import { SearchInput } from "../components/SearchInput";
import { LiveSyncPill } from "../components/LiveSyncPill";

export default function TopBar({ title }: { title: string }) {
  return (
    <header className="flex items-center gap-4 px-7 py-4 border-b border-border-subtle bg-bg-app">
      <h1 className="font-display text-lg font-semibold tracking-tight">{title}</h1>
      <div className="flex-1" />
      <SearchInput />
      <LiveSyncPill />
    </header>
  );
}
